<img class="plc-icon-badge__icon" [class]="iconClass" [src]="src" />

<span class="plc-icon-badge__badge" [class]="badgeClass">
	{{ formattedCounter }}
</span>
